import React from "react";

export default function CustomCard(props) {
  return (
    <>
      {props.data.map((item, index) => (
        <article className="custom-card" key={index}>
          <h1 className="custom-card-header">{item.name}</h1>
          <img className="custom-card-image" src={item.photo} alt="" loading="lazy" decoding="async" />
          <p className="custom-card-bio">{item.bio}</p>
        </article>
      ))}
    </>
  );
}
